import { useInfiniteQuery } from "hooks/useInfiniteQuery";
import { getStrategiesList } from "../service";
import { PAGE_SIZE } from "utils/constants";

export const useMarketplaceStrategies = ({
  category = "",
  sort = "",
  order = "desc",
  search = "",
  interval = "",
  label = "",
  enabled = true,
  additionalParams = {},
  size = PAGE_SIZE,
}) => {
  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useInfiniteQuery({
      key: "marketplaceStrategies",
      queryKey: [
        "marketplaceStrategies",
        category,
        sort,
        order,
        search,
        interval,
        label,
        size,
        Object.values(additionalParams).join("-"),
      ],
      queryFn: async ({ pageParam = 1 }) => {
        const params = {
          page: pageParam,
          size,
          category,
          sort,
          order,
          search,
          interval,
          label,
          ...additionalParams,
        };
        const response = await getStrategiesList(params);
        return {
          data: response.data,
          totalPages: response.total_pages,
          currentPage: pageParam,
        };
      },
      getNextPageParam: (lastPage) => {
        if (lastPage.currentPage < lastPage.totalPages) {
          return lastPage.currentPage + 1;
        }
        return undefined;
      },
      enabled,
    });

  const strategies = data?.pages.flatMap((page) => page.data) || [];

  return {
    strategies,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    totalPages: data?.pages[0]?.totalPages || 0,
  };
};
